import { PlanStatus } from '~/graphql/schema';

const STATUS_LABELS: Partial<Record<PlanStatus, string>> = {
  [PlanStatus.Deconverting]: 'Deconversion in progress',
  [PlanStatus.Deconverted]: 'Deconverted',
  [PlanStatus.Terminated]: 'Terminated',
  [PlanStatus.Terminating]: 'Termination in progress',
};

export const statusLabel = (status: PlanStatus | null | undefined): string | null =>
  (status && STATUS_LABELS[status]) ?? null;
